import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 5,
    paddingVertical: 2,
    borderRadius: 30,
  },
});
